import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const STAGING_BANNER_HEIGHT = 24; // Export for use in layouts

export function StagingBanner() {
  // Check if we're in staging environment via environment variable
  const isStaging = import.meta.env.VITE_APP_ENV === 'staging';

  if (!isStaging) {
    return null;
  }

  return (
    <Alert
      data-staging-banner
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-1.5 rounded-none border-0 border-b border-orange-300 bg-orange-100 p-0 text-orange-800"
      style={{ height: `${STAGING_BANNER_HEIGHT}px` }}
    >
      <AlertTriangle className="!static h-3.5 w-3.5 shrink-0 !text-orange-800" />
      <AlertDescription className="text-center text-xs font-medium tracking-wide [&_p]:leading-none">
        ESTE ES UN AMBIENTE DE PRUEBAS
      </AlertDescription>
    </Alert>
  );
}
